import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_HEADER_HIDE_BROWSE_LINK = createFcmConfig('header_hide_browse_link', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
